import StringList from "src/dataTypes/strings/StringList";
import NumberList from "src/dataTypes/numeric/NumberList";
import ColorListGenerators from "src/operators/graphic/ColorListGenerators";
import ColorOperators from "src/operators/graphic/ColorOperators";
import Table from "src/dataTypes/lists/Table";
import StringListOperators from "src/operators/strings/StringListOperators";
import NumberOperators from "src/operators/numeric/NumberOperators";
import { typeOf } from "src/tools/utils/code/ClassUtils";

/**
 * @classdesc  String Operators
 *
 * @namespace
 * @category strings
 */
function StringOperators() {}
export default StringOperators;

StringOperators.ENTER = String.fromCharCode(13);
StringOperators.ENTER2 = String.fromCharCode(10);
StringOperators.ENTER3 = String.fromCharCode(8232);

StringOperators.SPACE = String.fromCharCode(32);
StringOperators.SPACE2 = String.fromCharCode(160);

StringOperators.TAB = "	";
StringOperators.TAB2 = String.fromCharCode(9);

StringOperators.LINK_REGEX = /(^|\s+)(https*\:\/\/\S+[^\.\s+])/;

StringOperators.MAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

StringOperators.STOP_WORDS = StringList.fromArray("t,s,mt,rt,re,m,http,amp,a,able,about,across,after,all,almost,also,am,among,an,and,any,are,as,at,be,because,been,but,by,can,cannot,could,dear,did,do,does,either,else,ever,every,for,from,get,got,had,has,have,he,her,hers,him,his,how,however,i,if,in,into,is,it,its,just,least,let,like,likely,may,me,might,most,must,my,neither,no,nor,not,of,off,often,on,or,other,our,own,rather,said,say,says,she,should,since,so,some,than,that,the,their,them,then,there,these,they,this,tis,to,too,twas,us,wants,was,we,were,what,when,where,which,while,who,whom,why,will,with,would,yet,you,your".split(","));

StringOperators.WORDLISTS = {};
// lorem wordlist from https://github.com/f/loremjs/blob/master/lorem.js (first 5 sets)
StringOperators.WORDLISTS['lorem'] = StringList.fromArray(("lorem,ipsum,dolor,sit,amet,consectetur,adipiscing,elit,ut,aliquam,purus,sit,amet,luctus,venenatis,lectus,magna,fringilla,urna,porttitor,rhoncus,dolor,purus,non,enim,praesent,elementum,facilisis,leo,vel,fringilla,est,ullamcorper,eget,nulla,facilisi,etiam,dignissim,diam,quis,enim,lobortis,scelerisque,fermentum,dui,faucibus,in,ornare,quam,viverra,orci,sagittis,eu,volutpat,odio,facilisis,mauris,sit,amet,massa,vitae,tortor,condimentum,lacinia,quis,vel,eros,donec,ac,odio,tempor,orci,dapibus,ultrices,in,iaculis,nunc,sed,augue,lacus,viverra,vitae,congue,eu,consequat,ac,felis,donec,et,odio,pellentesque,diam,volutpat,commodo,sed,egestas,egestas,fringilla,phasellus,faucibus,scelerisque,eleifend,donec,pretium,vulputate,sapien,nec,sagittis,aliquam,malesuada,bibendum,arcu,vitae,elementum," + 
                                                    "curabitur,vitae,nunc,sed,velit,dignissim,sodales,ut,eu,sem,integer,vitae,justo,eget,magna,fermentum,iaculis,eu,non,diam,phasellus,vestibulum,lorem,sed,risus,ultricies,tristique,nulla,aliquet,enim,tortor,at,auctor,urna,nunc,id,cursus,metus,aliquam,eleifend,mi,in,nulla,posuere,sollicitudin,aliquam,ultrices,sagittis,orci,a,scelerisque,purus,semper,eget,duis,at,tellus,at,urna,condimentum,mattis,pellentesque,id,nibh,tortor,id,aliquet,lectus,proin,nibh,nisl,condimentum,id,venenatis,a,condimentum,vitae,sapien,pellentesque,habitant,morbi,tristique,senectus,et,netus,et,malesuada,fames,ac,turpis,egestas,sed,tempus,urna,et,pharetra,pharetra,massa,massa,ultricies,mi,quis,hendrerit,dolor,magna,eget,est,lorem,ipsum,dolor,sit,amet,consectetur,adipiscing,elit,pellentesque,habitant,morbi,tristique,senectus,et,netus,et,malesuada,fames,ac,turpis,egestas,integer,eget,aliquet,nibh,praesent,tristique,magna,sit,amet,purus,gravida,quis,blandit,turpis,cursus,in,hac,habitasse,platea,dictumst,quisque,sagittis,purus,sit,amet,volutpat,consequat,mauris,nunc,congue,nisi,vitae,suscipit,tellus,mauris,a,diam," +
                                                    "maecenas,sed,enim,ut,sem,viverra,aliquet,eget,sit,amet,tellus,cras,adipiscing,enim,eu,turpis,egestas,pretium,aenean,pharetra,magna,ac,placerat,vestibulum,lectus,mauris,ultrices,eros,in,cursus,turpis,massa,tincidunt,dui,ut,ornare,lectus,sit,amet,est,placerat,in,egestas,erat,imperdiet,sed,euismod,nisi,porta,lorem,mollis,aliquam,ut,porttitor,leo,a,diam,sollicitudin,tempor,id,eu,nisl,nunc,mi,ipsum,faucibus,vitae,aliquet,nec,ullamcorper,sit,amet,risus,nullam,eget,felis,eget,nunc,lobortis,mattis,aliquam,faucibus,purus,in,massa,tempor,nec,feugiat,nisl,pretium,fusce,id,velit,ut,tortor,pretium,viverra,suspendisse,potenti,nullam,ac,tortor,vitae,purus,faucibus,ornare,suspendisse,sed,nisi,lacus,sed,viverra,tellus,in,hac,habitasse,platea,dictumst,vestibulum,rhoncus,est,pellentesque,elit,ullamcorper,dignissim,cras,tincidunt,lobortis,feugiat,vivamus,at,augue,eget,arcu,dictum,varius,duis,at,consectetur,lorem," + 
                                                    "donec,massa,sapien,faucibus,et,molestie,ac,feugiat,sed,lectus,vestibulum,mattis,ullamcorper,velit,sed,ullamcorper,morbi,tincidunt,ornare,massa,eget,egestas,purus,viverra,accumsan,in,nisl,nisi,scelerisque,eu,ultrices,vitae,auctor,eu,augue,ut,lectus,arcu,bibendum,at,varius,vel,pharetra,vel,turpis,nunc,eget,lorem,dolor,sed,viverra,ipsum,nunc,aliquet,bibendum,enim,facilisis,gravida,neque,convallis,a,cras,semper,auctor,neque,vitae,tempus,quam,pellentesque,nec,nam,aliquam,sem,et,tortor,consequat,id,porta,nibh,venenatis,cras,sed,felis,eget,velit,aliquet,sagittis,id,consectetur,purus,ut,faucibus,pulvinar,elementum,integer,enim,neque,volutpat,ac,tincidunt,vitae,semper,quis,lectus,nulla,at,volutpat,diam,ut,venenatis,tellus,in,metus,vulputate,eu,scelerisque,felis,imperdiet,proin,fermentum,leo,vel,orci,porta,non,pulvinar,neque,laoreet,suspendisse,interdum,consectetur,libero,id,faucibus,nisl,tincidunt,eget,nullam,non,nisi,est,sit,amet,facilisis,magna," + 
                                                    "etiam,tempor,orci,eu,lobortis,elementum,nibh,tellus,molestie,nunc,non,blandit,massa,enim,nec,dui,nunc,mattis,enim,ut,tellus,elementum,sagittis,vitae,et,leo,duis,ut,diam,quam,nulla,porttitor,massa,id,neque,aliquam,vestibulum,morbi,blandit,cursus,risus,at,ultrices,mi,tempus,imperdiet,nulla,malesuada,pellentesque,elit,eget,gravida,sociis,natoque,penatibus,et,magnis,dis,parturient,montes,nascetur,ridiculus,mus,mauris,vitae,ultricies,leo,integer,malesuada,nunc,vel,risus,commodo,viverra,maecenas,accumsan,lacus,vel,facilisis,volutpat,est,velit,egestas,dui,id,ornare,arcu,odio,ut,sem,nulla,pharetra,diam,sit,amet,nisl,suscipit,adipiscing,bibendum,est,ultricies,integer,quis,auctor,elit,"
                                                    ).split(","));
StringOperators.WORDLISTS['greek'] = StringList.fromArray("alpha,beta,gamma,delta,epsilon,zeta,eta,theta,iota,kappa,lambda,mu,nu,xi,omicron,pi,rho,sigma,tau,upsilon,phi,chi,psi,omega".split(","));
StringOperators.WORDLISTS['fruit'] = StringList.fromArray("apple,banana,orange,grape,lemon,pineapple,strawberry,raspberry,mango".split(","));
StringOperators.WORDLISTS['female names'] = StringList.fromArray("Maria,Anne,Julia,Jacqueline,Susan,Raquel,Sarah,Alice,Emma,Adriana,Carmela,Bianca,Florence,Laura,Catherine,Ada,Louise,Helen,Kate,Lydia,Lucia,Marina,Marta,Marisa,Rosa,Sabrina,Erica".split(","));
StringOperators.WORDLISTS['male names'] = StringList.fromArray("James,John,Robert,Michael,William,David,Richard,Joseph,Charles,Thomas,Jonathan,Scott,Justin,Brandon,Benjamin,Patrick,Henry,Alexander,Petrer,Aaron,Giancarlo,Fernando,Giovanni,Marco,Mario,Samuel,Steven,Thomas,Victor".split(","));
StringOperators.WORDLISTS['last names']= StringList.fromArray("Smith,Johnson,Williams,Jones,Brown,Davis,Miller,Wilson,Moore,Taylor,Anderson,Thomas,Jackson,White,Harris,Martin,Thompson,Garcia,Martinez,Clark,Rodriguez,Lewis,Lee,Walker,Hall,Allen,Young,Hernandez,King,Wright,Lopez,Adams,Baker,Wong,Collins,Torres,Klein,Wood,Sanders,Washington,Bellini,de Groot,Casini,D'Angelo,Demarco".split(","));
StringOperators.WORDLISTS['cities'] = StringList.fromArray("San Francisco,New York,Chicago,London,Tokyo,Toronto,Rio de Janeiro,Mexico City,Seoul,Berlin,Rome,Barcelona".split(","));




///**
// * splits a String by a character (entre by default)
// * @param  {String} string
// *
// * @param  {String} character
// * @return {StringList}
// * tags:deprecated
// */
// StringOperators.split = function(string, character) {
//   if(character == null) return StringOperators.splitByEnter(string);
//   return StringList.fromArray(string.split(character));
// };


/**
 * split a String by enter (using several codifications)
 * @param  {String} string
 * @param {Boolean} trim optionally trims the texts (removing spaces at the beginning and end)
 * @return {StringList}
 * tags:transform
 */
StringOperators.splitByEnter = function(string,trim) {
  if(string == null) {
    return null;
  }
  var stringList = StringOperators.splitString(string, "\n", null, trim);
  if(stringList.length > 1)
  {
   return stringList;
  }
  stringList = StringOperators.splitString(string, StringOperators.ENTER2, null, trim);
  if(stringList.length > 1) {
    return stringList;
  }
  stringList = StringOperators.splitString(string, StringOperators.ENTER3, null, trim);
  if(stringList.length > 1) {
    return stringList;
  }
  return new StringList(string);
};


/**
 * replaces in a string ocurrences of a sub-string by another string (based on replace JavaScript method), you can use regex expressions such as /\n/ for enter or /[a|e]/ for multiple characters (see:https://regex101.com/)
 * @param  {String} text to be modified
 * @param  {String} string string to be replaced (could be Regular Expression)
 * @param  {String} replacement string to be placed instead
 * @return {String}
 * tags:transform
 * examples:jeff/examples/stringReplacements
 */
StringOperators.replaceStringInText = function(text, string, replacement) {
  if(text == null || string == null || replacement == null) return null;
  if(typeof text == 'object') return text;

  if(Object.prototype.toString.call(string) != '[object RegExp]'){
    string = String(string);
    var aParts = string.match(/\/(.+)\/(.*)/);
    if(aParts == null){
      // simple string pattern, replace all but with case specific (historical behaviour)
      string = StringListOperators._toRegEx(string);
    }
    else{
      // we have a regexp expressed as a string
      try{
        string = new RegExp(aParts[1],aParts[2]);
      }
      catch(err){
        throw err;
      }
    }
  }

  return String(text).replace(string, replacement);
};

/**
 * replaces substrings by a string (or by a a list of strings)
 * @param  {String} text where to replaces strings
 * @param  {StringList} strings to be replaced (could be Regular Expressions)
 * @param  {String|StringList} replacement string to be placed instead, or StringList with texts to be replaced (same size as strings)
 * 
 * @param {Boolean} asWords searches for words instead of string occurrences (using new RegExp("\\b" + string + "\\b"))
 * @return {String}
 * tags:transform
 * examples:jeff/examples/stringReplacements
 */
StringOperators.replaceStringsInText = function(text, strings, replacement, asWords) {
  if(text==null || strings==null || replacement==null) return null;

  var newText = text;
  var nStrings = strings.length;
  var j;
  var string;

  for(j=0; j<nStrings; j++){
    string = strings[j];
    if(asWords && Object.prototype.toString.call(string) != '[object RegExp]')
      string = new RegExp('\\b' + StringOperators.escapeForRegExp(string) + '\\b', 'g');
    newText = StringOperators.replaceStringInText(newText,string,Array.isArray(replacement)?String(replacement[j]):replacement) ;
  }

  return newText;
};

/**
 * remove text between strings
 * @param  {String} text to be modified
 * @param  {String} substring0
 * @param  {String} substring1
 *
 * @param {Boolean} includeSubstring0 (default:false) includes the substring0
 * @param {Boolean} includeSubstring1 (default:false) includes the substring1
 * @param {number} nMaxRemovals specify number of texts removed (for instance 1 will remove pnly the first block), (default:null, all blocks)
 * @return {String}
 * tags:transform,filter
 */
StringOperators.removeTextsBetweenStrings = function(text, substring0, substring1, includeSubstring0, includeSubstring1, nMaxRemovals) {
  if(text==null || substring0==null || substring1==null) return null;

  var reduce_nextstep = function(txt){
       var index0 = txt.indexOf(substring0);
       var index1 = txt.indexOf(substring1, index0);
       if(index0==-1 || index1==-1) return null;
       
       
       return txt.substr(0,index0-(includeSubstring0?substring0.length:0))+txt.substr(index1+(includeSubstring1?0:substring1.length));
   };
   
   var new_txt = reduce_nextstep(text);
   if(new_txt) text = new_txt;
   var n=1;
   nMaxRemovals = nMaxRemovals>0?nMaxRemovals:Number.MAX_SAFE_INTEGER;
   
   while(new_txt && n<nMaxRemovals){
       text = new_txt;
       new_txt = reduce_nextstep(text);
       n++;
   }
   
   return text;
};

/**
 * builds a stringList of words contained in the text
 * @param  {String} string text to be analyzed
 *
 * @param  {Boolean} withoutRepetitions remove words repetitions (default:true)
 * @param  {Boolean|StringList} stopWords remove stop words (true for using default list of stop words, or stringList of words)
 * @param  {Boolean} sortedByFrequency  sorted by frequency in text (default: true)
 * @param  {Boolean} includeLinks include html links
 * @param  {Number} limit of words
 * @param  {Number} minSizeWords minimal number of characters of words
 * @param  {String} wordDelimiter default is ' ' in which case words are defined in the usual way. Anything else and the input is simply split by that string and the results trimmed
 * @return {StringList}
 * tags:extract
 */
StringOperators.getWords = function(string, withoutRepetitions, stopWords, sortedByFrequency, includeLinks, limit, minSizeWords, wordDelimiter) {
  if(string == null) return null;

  var links;

  minSizeWords = minSizeWords || 0;
  withoutRepetitions = withoutRepetitions == null ? true : withoutRepetitions;
  sortedByFrequency = sortedByFrequency == null ? true : sortedByFrequency;
  includeLinks = includeLinks == null ? true : includeLinks;
  limit = limit == null ? 0 : limit;
  wordDelimiter = (wordDelimiter == null || wordDelimiter == '') ? ' ' : wordDelimiter;

  var regexlink = StringOperators.LINK_REGEX;
  var i, j, list;
  if(typeof string != 'string')
    string = String(string);
  if(includeLinks) {
    links = string.match(regexlink);
  }


  string = string.toLowerCase().replace(regexlink,"");

  if(wordDelimiter == ' '){
    // regexp \w in javascript is same as [A-Za-z_0-9] and does not include accented characters
    // This expression below works for latin-based languages but not Cyrillic or Chinese
    list = string.match(/[A-Za-z_0-9À-ÖØ-öø-ÿ]+/g);
  }
  else
    list = StringOperators.splitString(string,wordDelimiter,null,true);

  if(list == null) return new StringList();

  list = StringList.fromArray(list);
  list = list.getFilteredByFunction(function(val){ return val != ''});

  if(includeLinks && links != null) list = list.concat(links);
  if(wordDelimiter == ' ')
    list = StringList.fromArray(list).replace(/ /g, "");

  var nMatches;

  if(stopWords != null) {
    var bUseOldMethod = true;
    if(stopWords===true){
      stopWords = StringOperators.STOP_WORDS;
      bUseOldMethod = false;
    }
    else{
      bUseOldMethod = false;
      for(j = 0; j < stopWords.length; j++){
        if(typeof stopWords[j] == 'object'){
          // regular exp
          bUseOldMethod = true;
          break;
        }
      }
    }

    if(bUseOldMethod){
      nMatches = list.length;
      var nStopWords = stopWords.length;
      for(i = 0; i<nMatches; i++) {
        for(j = 0; j<nStopWords; j++) {
          if((typeof stopWords[j]) == 'string') {
            if(stopWords[j] == list[i]) {
              list.splice(i, 1);
              i--;
              nMatches = list.length;
              break;
            }
          } else if(stopWords[j].test(list[i])) {
            list.splice(i, 1);
            i--;
            nMatches = list.length;
            break;
          }
        }
      }
    }
    else{
      // much faster than old method when we have stop words
      list = list.getWithoutElements(stopWords);
      nMatches = list.length;
    }
  }

  if(minSizeWords > 0) {
    nMatches = list.length;
    for(i = 0; i<nMatches; i++) {
      if(list[i].length < minSizeWords) {
        list.splice(i, 1);
        i--;
        nMatches = list.length;
      }
    }
  }

  if(sortedByFrequency) {
    if(withoutRepetitions)
      list = list.getFrequenciesTable(true)[0];// //ListOperators.countElementsRepetitionOnList(list, true)[0];
    else {
      var occurrences = list.getFrequenciesTable();
      var list2 = new StringList();
      for(i=0; i < occurrences[0].length; i++){
        for(var j=0; j < occurrences[1][i]; j++)
          list2.push(occurrences[0][i]);
      }
      list = list2;
    }

    if(limit !== 0) list = list.splice(0, limit);

    return list;
  }

  if(withoutRepetitions) {
    list = list.getWithoutRepetitions();
  }

  if(limit !== 0) list = list.splice(0, limit);
  return list;
};



/**
 * return a substring
 * @param  {String} string
 *
 * @param  {Number} i0 init index
 * @param  {Number} length of ths substring (if null returns substring from i0 to the end)
 * @return {String}
 * tags:filter
 */
StringOperators.substr = function(string, i0, length) {
  if(string == null) return null;
  i0 = i0 || 0;
  return string.substr(i0, length);
};

/**
 * split a String by a separator (a String) and returns a StringList
 * @param  {String} string
 *
 * @param  {String} separator (default: ",")
 * @param  {Number} segments if specified then split string into this many segments. The segments are roughly equal in size and split at word boundaries if possible.
 * @param {Boolean} trim optionally trims resulting texts (so they don't start or end with spaces)
 * @return {StringList}
 * tags:
 */
StringOperators.splitString = function(string, separator, segments, trim) {
  if(string == null) return null;
  if(segments != null && !isNaN(segments) && segments != 0){
    var aWords = string.match(/\w+/g);
    if(aWords == null)
      aWords = [string];
    var bSplitAtWordBoundary = true;
    var fShrinkShift = string.length/aWords.length/2;
    if(segments > aWords.length){
      bSplitAtWordBoundary = false;
      fShrinkShift = 0;
    }
    var sL = new StringList();
    var ss, sRemaining = string, indexOfBreak, size;

    while(sRemaining.length > 0){
      size = Math.max(1,Math.floor(sRemaining.length / (segments - sL.length) - fShrinkShift));
      if(sL.length == segments - 1){
        sL.push(sRemaining);
        break;
      }
      indexOfBreak = bSplitAtWordBoundary ? sRemaining.substring(size - 1).search(/\s/) : 0;
      if(indexOfBreak == -1)
        indexOfBreak = size;
      else
        indexOfBreak += size;
      ss = sRemaining.substring(0,indexOfBreak);
      sL.push(ss);
      sRemaining = sRemaining.substring(indexOfBreak);
    }
    if(trim) return sL.trim();
    return sL;
  }

  if(separator == null) separator = ",";
  if(typeof separator == "string") separator = separator.replace("\\n", "\n");
  if(string.indexOf(separator) == -1) return new StringList(string);

  sL = StringList.fromArray(string.split(separator));

  if(trim) return sL.trim();
  return sL;
};

/**
 * searches for two Strings within a String and returns the String in between
 * @param  {String} text
 * @param  {String} subString0
 *
 * @param  {String} subString1 if null returns the text after subString0
 * @return {String}
 * tags:filter,extract
 */
StringOperators.getFirstTextBetweenStrings = function(text, subString0, subString1) {
  if(text == null) return null;
  var i0 = text.indexOf(subString0);
  if(i0 == -1) return null;
  if(subString1 === "" || subString1 == null) return text.substr(i0 + subString0.length);
  var i1 = text.indexOf(subString1, i0 + subString0.length + 1);
  if(i1 == -1) return text.substring(i0 + subString0.length);
  return text.substr(i0 + subString0.length, i1 - (i0 + subString0.length));
};

/**
 * searches all the Strings contained between two Strings in a String
 * @param  {String} text
 * @param  {String} subString0
 * @param  {String} subString1
 * @return {StringList}
 * tags:filter,extract
 */
StringOperators.getAllTextsBetweenStrings = function(text, subString0, subString1) { //TODO: improve using indexOf(string, START_INDEX)
  if(text == null) return null;
  if(text.indexOf(subString0) == -1) return new StringList();
  var blocks = text.split(subString0);
  var nBlocks = blocks.length;
  var stringList = new StringList();
  var block;
  var index;
  var i;
  for(i = 1; i < nBlocks; i++) {
    block = blocks[i];
    if(subString1 == subString0) {
      stringList.push(block);
    } else {
      index = block.indexOf(subString1);
      if(index >= 0) {
        stringList.push(block.substr(0, index));
      }
    }
  }
  return stringList;
};

/**
 * associates a value to each text in a StringList, according to number of words containg in each StringList; one lists pushes to negative values, the other to positive. A classic use would be a primitive sentimental analisis using a list of positive adjectives and a list of negative ones
 * @param  {String|StringList} string or stringList to be analized
 * @param  {StringList} negativeStrings list of 'negative' words
 * @param  {StringList} positiveStrings list of 'positive' words
 *
 * @param  {Boolean} normalizeBySize divide score by the string size
 * @return {Number|NumberList}
 * tags:analysis,metric
 * examples:santiago/examples/countWordsDichotomyAnalysis
 */
StringOperators.countWordsDichotomyAnalysis = function(string, negativeStrings, positiveStrings, normalizeBySize) {
  if(string==null) return null;
  if(string["isList"]){
    var weights = new NumberList();
    for(var i=0; i<string.length; i++){
      weights[i] = StringOperators.countWordsDichotomyAnalysis(string[i], negativeStrings, positiveStrings, normalizeBySize);
    }
    return weights;
  }
  var val = 0;
  negativeStrings.forEach(function(word) {
    val -= StringOperators.countWordOccurrences(string, word);
  });
  positiveStrings.forEach(function(word) {
    val += StringOperators.countWordOccurrences(string, word);
  });
  if(normalizeBySize) val /= string.length;
  return val;
};


/**
 * creates a list of urls contained in the html in &lt;a&gt; tags
 * @param  {String} html to be analyzied
 *
 * @param {String} urlSource optional, if provided will be used to build complete urls
 * @param {Boolean} removeHash if true removes the hastag (anchor) content of the url
 * @return {StringList} list of urls
 * tags:html
 */
StringOperators.getLinksFromHtml = function(html, urlSource, removeHash) {
  var doc = document.createElement("html");
  doc.innerHTML = html;

  var i;
  var links = doc.getElementsByTagName("a");
  var originalUrl, url;
  var urls = new StringList();
  var index;
  var urlSourceParts;
  var parts, blocks;
  var root;

  urlSource = urlSource === "" ? null : urlSource;
  removeHash = removeHash == null ? false : removeHash;

  if(urlSource) {
    urlSource = urlSource.trim();

    if(urlSource.substr(-5) == ".html") {
      urlSourceParts = urlSource.split("/");
      urlSource = urlSourceParts.slice(0, urlSourceParts.length - 1).join("/");
    }
    if(urlSource.indexOf(-1) == "/") urlSource = urlSource.substr(0, urlSource.length - 1);
    urlSourceParts = urlSource.split("/");

    root = urlSource.replace("//", "**").split("/")[0].replace("**", "//");
  }


  for(i = 0; i < links.length; i++) {
    originalUrl = url = links[i].getAttribute("href");
    if(url == null) continue;

    if(url.indexOf('=') != -1) url = url.split('=')[0];

    //console.log(url);
    if(urlSource && url.indexOf('http://') == -1 && url.indexOf('https://') == -1 && url.indexOf('wwww.') == -1 && url.indexOf('file:') == -1 && url.indexOf('gopher:') == -1 && url.indexOf('//') !== 0) {
      if(url.substr(0, 9) == "../../../") {
        url = urlSourceParts.slice(0, urlSourceParts.length - 3).join("/") + "/" + url.substr(9);
      } else if(url.substr(0, 6) == "../../") {
        url = urlSourceParts.slice(0, urlSourceParts.length - 2).join("/") + "/" + url.substr(6);
      } else if(url.substr(0, 3) == "../") {
        url = urlSourceParts.slice(0, urlSourceParts.length - 1).join("/") + "/" + url.substr(3);
      } else if(url.charAt(0) == "/") {
        url = root + url;
      } else {
        url = urlSource + "/" + url;
      }
    }
    if(removeHash && url.indexOf("#") != -1) url = url.split('#')[0];
    if(url.substr(-1) == "/") url = url.substr(0, url.length - 1);

    index = url.indexOf('/../');
    while(index != -1) {
      blocks = url.split('/../');
      parts = blocks[0].replace("//", "**").split("/");
      url = parts.slice(0, parts.length - 1).join("/").replace("**", "//") + ("/" + blocks.slice(1).join("/../"));
      index = url.indexOf('/../');
    }

    if(url.indexOf('./') != -1) {
      parts = url.replace("//", "**").split("/");
      if(parts[0].substr(-1) == ".") {
        parts[0] = parts[0].substr(0, parts[0].length - 1);
        url = parts.join('/').replace("**", "//");
      }
    }

    url = url.trim();

    if(url.substr(-1) == "/") url = url.substr(0, url.length - 1);

    if(url == urlSource) continue;
    //console.log(urlSource+' | '+originalUrl+' -> '+url);
    urls.push(url);
  }

  urls = urls.getWithoutRepetitions();

  return urls;
};


/**
 * validates is string contains another string, as string or word (space or punctuation boundaries)
 * @param {String} text string to be validated
 * @param {String} string string or word to be searched
 *
 * @param {Boolean} asWord if true a word will be searched (false by default)
 * @param {Boolean} caseSensitive (false by default)
 * @return {Boolean} returns true if string or word is contained
 */
StringOperators.textContainsString = function(text, string, asWord, caseSensitive) {
  text = caseSensitive ? string : text.toLowerCase();
  string = caseSensitive ? string : string.toLowerCase();
  return asWord ?
    text.match(new RegExp("\\b" + string + "\\b")).length > 0 :
    text.indexOf(string) != -1;
};

/**
 * print a string in console
 * @param  {String} string to be printed in console
 * @param  {Boolean} frame  if true (default) prints ///////////////// on top and bottom
 * tags:special
 */
StringOperators.logInConsole = function(string, frame) {
  frame = frame == null ? true : frame;
  if(frame) console.log('///////////////////////////////////////////////////');
  console.log(string);
  if(frame) console.log('///////////////////////////////////////////////////');
};




//////


/**
 * @todo finish docs
 */
StringOperators.getParenthesisContents = function(text, brackets) {
  var contents = new StringList();

  var subText = text;

  var contentObject = StringOperators.getFirstParenthesisContentWithIndexes(text, brackets);

  var nAttempts = 0;
  while(contentObject.content !== "" && contentObject.index1 < subText.length - 1 && nAttempts < text.length) {
    contents.push(contentObject.content);
    subText = subText.substr(contentObject.index1 + 2);
    contentObject = StringOperators.getFirstParenthesisContentWithIndexes(subText, brackets);
    nAttempts++;
  }

  return contents;
};

/**
 * @todo finish docs
 */
StringOperators.getFirstParenthesisContent = function(text, brackets) {
  return StringOperators.getFirstParenthesisContentWithIndexes(text, brackets).content;
};

/**
 * @todo finish docs
 */
StringOperators.getFirstParenthesisContentWithIndexes = function(text, brackets) {
  var open = brackets ? "[" : "(";
  var close = brackets ? "]" : ")";

  var openRegEx = brackets ? /\[/g : /\(/g;
  var closeRegEx = brackets ? /\]/g : /\)/g;

  var indexOpen = text.indexOf(open);

  if(indexOpen == -1) return {
    "content": "",
    "index0": 0,
    "index1": 0
  };

  var indexClose = text.indexOf(close);

  var part = text.substring(indexOpen + 1, indexClose);

  var openMatch = part.match(openRegEx);
  var closeMatch = part.match(closeRegEx);

  var nOpen = (openMatch == null ? 0 : openMatch.length) - (closeMatch == null ? 0 : closeMatch.length);
  var nAttempts = 0;


  while((nOpen > 0 || indexClose == -1) && nAttempts < text.length) {
    indexClose = text.indexOf(close, indexClose);
    part = text.substring(indexOpen + 1, indexClose + 1);
    indexClose++;
    openMatch = part.match(openRegEx);
    closeMatch = part.match(closeRegEx);
    nOpen = (openMatch == null ? 0 : openMatch.length) - (closeMatch == null ? 0 : closeMatch.length);

    nAttempts++;
  }
  indexClose = text.indexOf(close, indexClose);

  return {
    "content": indexClose == -1 ? text.substring(indexOpen + 1) : text.substring(indexOpen + 1, indexClose),
    "index0": indexOpen + 1,
    "index1": indexClose == -1 ? (text.length - 1) : (indexClose - 1)
  };
};

/**
 * @todo finish docs
 */
StringOperators.placeString = function(string, stringToPlace, index) {
  return string.substr(0, index) + stringToPlace + string.substr(index + stringToPlace.length);
};

/**
 * @todo finish docs
 */
StringOperators.insertString = function(string, stringToInsert, index) {
  return string.substr(0, index) + stringToInsert + string.substr(index);
};

/**
 * transforms a text by performing multiple optional cleaning operations (applied in the same order as parameters suggest)
 * @param {String|StringList} string to be transformed (also receives a StringList)
 *
 * @param {Boolean} rmvEnters
 * @param {Boolean} rmvTabs
 * @param {String} replaceTabsAndEntersBy
 * @param {Boolean} rmvPunctuation
 * @param {Boolean} toLowerCase
 * @param {StringList} stopWords removes strings from text
 * @param {Boolean} rmveDoubleSpaces
 * @param {Boolean} rmveAccentsAndDiacritics removes accents and diacritics from characters
 * @return {String}
 * tags:filter,transform,clean
 * examples:santiago/tests/cleanTexts
 */
StringOperators.cleanText = function(string, rmvEnters, rmvTabs, replaceTabsAndEntersBy, rmvPunctuation, toLowerCase, stopWords, rmveDoubleSpaces, rmveAccentsAndDiacritics){
  if(string==null) return null;
  if(string["isList"]) return StringListOperators.cleanTexts(string, rmvEnters, rmvTabs, replaceTabsAndEntersBy, rmvPunctuation, toLowerCase, stopWords, rmveDoubleSpaces, rmveAccentsAndDiacritics);
  
  //console.log("string["+string+"]");

  if(rmvEnters) string = StringOperators.removeEnters(string, replaceTabsAndEntersBy);
  if(rmvTabs) string = StringOperators.removeTabs(string, replaceTabsAndEntersBy);
  if(rmvPunctuation) string = StringOperators.removePunctuation(string);
  if(toLowerCase) string = string.toLowerCase();

  if(stopWords != null){
    string = StringOperators.replaceStringsInText(string, stopWords, "", true);
  }

  if(rmveDoubleSpaces) string = StringOperators.removeDoubleSpaces(string);

  if(rmveAccentsAndDiacritics) string = StringOperators.removeAccentsAndDiacritics(string);

  return string;
};

/**
 * removes enters from string
 * @param {String} string to be transformed

 * @param {String} replaceBy optional string to replace enters
 * @return {String}
 * tags:transform,clean
 */
StringOperators.removeEnters = function(string, replaceBy) {
  if(string==null) return null;
  replaceBy = replaceBy==null?"":replaceBy;
  //var r = new RegExp('\\'+StringOperators.ENTER+'|\\'+StringOperators.ENTER2+'|\\'+StringOperators.ENTER3,'gi');
  //var r = new RegExp('\n|\r','gi');
  return string.replace(/(\r|\n)/g, replaceBy);
};

/**
 * removes tabs from string
 * @param {String} string to be transformed

 * @param {String} replaceBy optional string to replace tabs
 * @return {String}
 * tags:transform,clean
 */
StringOperators.removeTabs = function(string, replaceBy) {
  if(string==null) return null;
  replaceBy = replaceBy || "";
  //var r = new RegExp('\\'+StringOperators.TAB+'|\\'+StringOperators.TAB2+'|\\t','gi');
  return string.replace(/\t/g, replaceBy);
};

/**
 * removes punctuation from a string, using regex /[:,.;?!\(\)\"\']/gi
 * @param {String} string to be transformed

 * @param {String} replaceBy optional string to replace punctuation signs
 * @return {String}
 * tags:transform,clean
 */
StringOperators.removePunctuation = function(string, replaceBy) {
  if(string==null) return null;
  replaceBy = replaceBy || "";
  return string.replace(/[:,.;?!\(\)\"\']/gi, replaceBy);
};

/**
 * removes double spaces from a string
 * @param {String} string to be transformed
 * @return {String}
 * tags:transform,clean
 */
StringOperators.removeDoubleSpaces = function(string) {
  if(string==null) return null;
  var retString = string;
  var regExpr = RegExp(/  /);
  while(regExpr.test(retString)) {
    retString = retString.replace(regExpr, " ");
  }
  return retString;
};

/**
 * @todo finish docs
 */
StringOperators.removeInitialRepeatedCharacter = function(string, character) {
  if(string==null) return null;
  while(string.charAt(0) == character) string = string.substr(1);
  return string;
};


/**
 * takes plain text from html
 * @param  {String} html
 * @return {String}
 * tags:transform,clean
 */
StringOperators.removeHtmlTags = function(html) {
  var tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText;
};

/**
 * translates HTML entities in text (&&lt;&gt;"'/) to html entity codes
 * @param  {String} text to escape
 * @return {String}
 * tags:transform,clean
 */
StringOperators.escapeForHtml = function(text) {
  if(text==null) return null;
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '/': '&#x2F;'
  };
  return ('' + text).replace(/[&<>"'\/]/g, function(match) {
    return htmlEscapes[match];
  });
};

/**
 * escape any character in text that gets interpreted by RegExp with a backslash
 * @param  {String} text to escape
 * @return {String}
 */
StringOperators.escapeForRegExp = function(text) {
  if(text==null) return null;
  return text.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
};

/**
 * @todo finish docs
 */
StringOperators.removeLinks = function(text) {
  text += ' ';
  var regexp = /https*:\/\/[a-zA-Z0-9\/\.]+( |:|;|\r|\t|\n|\v)/g;
  return(text.replace(regexp, ' ')).substr(0, text.length - 2);
};

/**
 * @todo finish docs
 */
StringOperators.removeQuotes = function(string) { //TODO:improve
  if(string.charAt(0) == "\"") string = string.substr(1);
  if(string.charAt(string.length - 1) == "\"") string = string.substr(0, string.length - 1);
  return string;
};

// StringOperators.trim = function(string){
// 	return string.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
// }


/**/
StringOperators.removeAccentsAndDiacritics = function(string) {
  var r = string.replace(new RegExp(/[àáâãäå]/g), "a");
  r = r.replace(new RegExp(/æ/g), "ae");
  r = r.replace(new RegExp(/ç/g), "c");
  r = r.replace(new RegExp(/[èéêë]/g), "e");
  r = r.replace(new RegExp(/[ìíîï]/g), "i");
  r = r.replace(new RegExp(/ñ/g), "n");
  r = r.replace(new RegExp(/[òóôõö]/g), "o");
  r = r.replace(new RegExp(/œ/g), "oe");
  r = r.replace(new RegExp(/[ùúûü]/g), "u");
  r = r.replace(new RegExp(/[ýÿ]/g), "y");

  r = r.replace(new RegExp(/[ÀÁÂÄÃ]/g), "A");
  r = r.replace(new RegExp(/Æ/g), "AE");
  r = r.replace(new RegExp(/Ç/g), "c");
  r = r.replace(new RegExp(/[ÈÉÊË]/g), "E");
  r = r.replace(new RegExp(/[ÌÍÎÏ]/g), "I");
  r = r.replace(new RegExp(/Ñ/g), "N");
  r = r.replace(new RegExp(/[ÒÓÔÖÕ]/g), "O");
  r = r.replace(new RegExp(/Œ/g), "OE");
  r = r.replace(new RegExp(/[ÙÚÛÜ]/g), "U");
  r = r.replace(new RegExp(/[Ÿ]/g), "Y");

  return r;
};

/**
 * creates a table with frequent words and occurrences numbers
 * @param  {String} string text to be analyzed
 *
 * @param  {StringList|Number} stopWords optional list of stop words, if values is 1 default stop words will be used
 * @param  {Boolean} includeLinks
 * @param  {Number} limit max size of rows
 * @param  {Number} minSizeWords
 * @param  {String} wordDelimiter default is ' ' in which case words are defined in the usual way. Anything else and the input is simply split by that string and the results trimmed
 * @return {Table} contains a list of words, and a numberList of occurrences
 * tags:words,count
 */
StringOperators.getWordsOccurrencesTable = function(string, stopWords, includeLinks, limit, minSizeWords, wordDelimiter) {
  if(string == null) return;
  if(string.length === 0) return new Table(new StringList(), new NumberList());

  if(stopWords==1) stopWords = StringOperators.STOP_WORDS;

  var words = StringOperators.getWords(string, false, stopWords, false, includeLinks, null, minSizeWords, wordDelimiter);
  var table;
  if(limit != null)
    table = words.getFrequenciesTable(true).sliceRows(0, limit-1);
  else
    table = words.getFrequenciesTable(true);
  table[0].name = 'Word';
  table[1].name = 'Frequency';
  return table;// ListOperators.countElementsRepetitionOnList(words, true, false, limit);
};


/**
 * @todo finish docs
 */
StringOperators.indexesOf = function(text, string, asWord) { //TODO:test
  var indexes, index;
  
  if(asWord){
    indexes  = new NumberList();

    console.log("---");

    string = new RegExp("\\b" + string + "\\b");
    index = text.search(string);
    if(index!=-1) text = text.substr(index);
    var prev;
    while(index != -1){
      indexes.push(index);
      prev = index;
      index = text.search(string);
      text = text.substr(index+1);
      if(index>=0) index+=prev;
    }
    return indexes;
  }

  index = text.indexOf(string);
  if(index == -1) return new NumberList();
  indexes  = new NumberList(index);

  index = text.indexOf(string, index + 1);

  while(index != -1) {
    indexes.push(index);
    index = text.indexOf(string, index + 1);
  }
  return indexes;
};

/**
 * returns a list of positions of substring
 * @param  {String} text
 * @param  {String} string substring to search
 *
 * @param {Boolean} asWord search string as word (default:false)
 * @return {NumberList}
 * tags:search
 */
StringOperators.indexesOfString = function(text, string, asWord){
  if(text == null || string == null) return null;
  return StringOperators.indexesOf(text, string, asWord);
};

/**
 * returns a string repeated a number of times
 * @param  {String} text to be repeated
 * @param  {Number} n number of repetitions
 * @return {String}
 * tags:generator
 */
StringOperators.repeatString = function(text, n) {
  var i;
  var newText = "";
  for(i = 0; i < n; i++) {
    newText += text;
  }
  return newText;
};



/**
 * count the number of occurrences of a string into a text
 * @param {String} text
 * @param {String} string
 *
 * @param {Boolean} asWord if false (default) searches for substring, if true searches for word
 * @return {Number} number of occurrences
 * tags:count
 */
StringOperators.countStringOccurrences = function(text, string, asWord) {
  if(text == null || string == null) return null;
  return StringOperators.countOccurrences(text, string, asWord);
};


/**
 * bridged by countStringOccurrences, there's a countOccurrences for Lists
 */
StringOperators.countOccurrences = function(text, string, asWord) { //seems to be th emost efficient: http://stackoverflow.com/questions/4009756/how-to-count-string-occurrence-in-string
  if(asWord) return StringOperators.countWordOccurrences(text, string);

  var n = 0;
  var index = text.indexOf(string);
  while(index != -1) {
    n++;
    index = text.indexOf(string, index + string.length);
  }
  return n;
};

/**
 * @todo finish docs
 */
StringOperators.countWordOccurrences = function(string, word) {
  var regex = new RegExp("\\b" + word + "\\b");
  return StringOperators.countRegexOccurrences(string, regex);
};

/**
 * @todo finish docs
 */
StringOperators.countRegexOccurrences = function(string, regex) {
  var match = string.match(regex);
  return match == null ? 0 : match.length;
};

/**
 * count the number of occurrences of a list of strings into a text
 * @param {String} text
 * @param {StringList} strings
 *
 * @param {Boolean} asWords if false (default) searches for substrings, if true searches for words
 * @return {NumberList} number of occurrences per string
 * tags:count
 */
StringOperators.countStringsOccurrences = function(text, strings, asWords) {
  if(text==null || strings==null) return;

  var i;
  var numberList = new NumberList();
  var nStrings = strings.length;
  for(i = 0; i<nStrings; i++) {
    if(asWords){
      numberList[i] = StringOperators.countRegexOccurrences(text, new RegExp("\\b" + strings[i] + "\\b"));
    } else {
      numberList[i] = StringOperators.countOccurrences(text, strings[i]);
    }
  }
  return numberList;
};

//validation

/**
 * @todo finish docs
 */
StringOperators.validateEmail = function(text) {
  return StringOperators.MAIL_REGEX.test(text);
};

/**
 * @todo finish docs
 */
StringOperators.validateUrl = function(text) {
  return StringOperators.LINK_REGEX.test(text);
};


/**
 * creates an html string that depicts a proprtions bar with colors for categories
 * @param  {NumberList} normalizedWeights normalized weights
 *
 * @param  {Number} nChars width in characters
 * @param  {ColorList} colors list of categorical colors
 * @param  {String} character character or characters to be used as primitive
 * @return {String} html depciting colored segments forming a bar in a single line
 */
StringOperators.createsCategoricalColorsBlocksHtml = function(normalizedWeights, nChars, colors, character){
  if(normalizedWeights==null) return "";

  var bars="";

  nChars = nChars==null?20:nChars;
  colors = colors==null?ColorListGenerators.createDefaultCategoricalColorList(normalizedWeights.length):colors;
  character = character==null?"█":character;

  NumberOperators.randomSeed(37);
  normalizedWeights.forEach(function(w, j){
    w = Math.floor(w*nChars) +  ( (w*nChars - Math.floor(w*nChars))>NumberOperators.random()?1:0 );
    bars += "<font color=\""+ColorOperators.colorStringToHEX(colors[j])+"\">";
    for(var i=0; i<w; i++){
      bars += character;
    }
    bars += "</f>";
  });
  NumberOperators.randomSeedPop();

  return bars;
};

/**
 * calculate the Levenshtein (aka edit) Distance between two strings
 * @param {String} text1
 * @param {String} text2
 *
 * @param {Boolean} bNormalized if true normalize by maximum input length so number varies from 0 (identical) to 1 (completely different)
 * @return {Number} edit distance
 * tags:distance,analysis
 * examples:jeff/examples/EditDistance
 */
StringOperators.getLevenshteinDistance = function(a, b, bNormalized) {
/*
Copyright (c) 2011 Andrei Mackenzie
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
documentation files (the "Software"), to deal in the Software without restriction, including without limitation the
rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

  // treat null like empty string
  a = a == null ? '' : a;
  b = b == null ? '' : b;
  if(a.length === 0 && b.length === 0) return 0;
  if(a.length === 0) return bNormalized ? 1 : b.length;
  if(b.length === 0) return bNormalized ? 1 : a.length;

  var matrix = [];

  // increment along the first column of each row 
  var i;
  for(i = 0; i <= b.length; i++){
    matrix[i] = [i];
  }

  // increment each column in the first row
  var j;
  for(j = 0; j <= a.length; j++){
    matrix[0][j] = j;
  }

  // Fill in the rest of the matrix
  for(i = 1; i <= b.length; i++){
    for(j = 1; j <= a.length; j++){
      if(b.charAt(i-1) == a.charAt(j-1)){
        matrix[i][j] = matrix[i-1][j-1];
      } else {
        matrix[i][j] = Math.min(matrix[i-1][j-1] + 1, // substitution
                                Math.min(matrix[i][j-1] + 1, // insertion
                                         matrix[i-1][j] + 1)); // deletion
      }
    }
  }

  if(bNormalized){
    var levn = matrix[b.length][a.length]/Math.max(a.length,b.length);
    return Number(levn.toFixed(5)); // no need to get really precise
  }

  return matrix[b.length][a.length];
};

/**
 * calculate distance between two strings based on letter bigram set similarity. Returns 0 for identical, 1 for maximally different.
 * @param {string} first
 * @param {string} second
 *
 * @param {boolean} bIgnoreSpaces if true then remove all whitespace before comparison (default:false)
 * @return {Number} edit distance
 * tags:distance,analysis
 * examples:jeff/examples/EditDistance
 */
StringOperators.getDiceBigramDistance = function(first, second, bIgnoreSpaces) {
  // Code mostly from https://github.com/aceakash/string-similarity
  // treat null like empty string
  first = first == null ? '' : String(first);
  second = second == null ? '' : String(second);
  bIgnoreSpaces = bIgnoreSpaces == null ? false : bIgnoreSpaces;
  if(bIgnoreSpaces){
    first = first.replace(/\s+/g, '')
    second = second.replace(/\s+/g, '')
  }

  if (first === second) return 0; // identical or empty
  if (first.length < 2 || second.length < 2) return 1; // if either is a 0-letter or 1-letter string

  let firstBigrams = new Map();
  for (let i = 0; i < first.length - 1; i++) {
    const bigram = first.substring(i, i + 2);
    const count = firstBigrams.has(bigram)
      ? firstBigrams.get(bigram) + 1
      : 1;

    firstBigrams.set(bigram, count);
  };

  let intersectionSize = 0;
  for (let i = 0; i < second.length - 1; i++) {
    const bigram = second.substring(i, i + 2);
    const count = firstBigrams.has(bigram)
      ? firstBigrams.get(bigram)
      : 0;

    if (count > 0) {
      firstBigrams.set(bigram, count - 1);
      intersectionSize++;
    }
  }

  return 1 - (2.0 * intersectionSize) / (first.length + second.length - 2);
}

StringOperators.isAbsoluteUrl = function(string){
  if(string==null) return null;

  var cases = ["http://", "https://", "fttp://", "fttps://"];
  for(var i=0; i<cases.length; i++){
    if(string.indexOf(cases[i])===0) return true;
  }

  return false;
};

/**
 * builds a stringList of word sequences of 2,3,…n words, contained in the text
 * @param  {String} text to be analyzed, (it has to have more than two words)
 *
 * @param  {Number} minSequenceSize least amount of words in sequence (default:2)
 * @param  {Number} maxSequenceSize most amount of words in sequence (default:2)
 * @param  {Boolean|StringList} stopWords do not allow stop words (true for default stop words, or stringList of words)
 * @param  {Number} limit to the number of sequences
 * @param  {Number} minSizeWords minimal number of characters of words
 * @param  {Number} iStopwordMode 0: no stop words allowed (default if stopwords defined)<br>1: any word allowed (default if stopwords not defined)<br>2: allow interior stop words only
 * @return {StringList}
 * tags:extract,analysis
 */
StringOperators.getNgrams = function(text, minSequenceSize, maxSequenceSize, stopWords, limit, minSizeWords, iStopwordMode) {
  
  minSequenceSize = minSequenceSize || 2;
  maxSequenceSize = maxSequenceSize || 2;
  if(maxSequenceSize < minSequenceSize) maxSequenceSize = minSequenceSize;
  minSizeWords = minSizeWords || 0;
  limit = limit == null ? 0 : limit;
  if(stopWords===true) stopWords = StringOperators.STOP_WORDS;
  iStopwordMode = iStopwordMode == null ? (stopWords == null ? 1 : 0) : iStopwordMode;
  if(iStopwordMode != 1 && stopWords == null) stopWords = StringOperators.STOP_WORDS;
  if(iStopwordMode == 1) stopWords=null;
  
  var i, j, sSeq;
  var sLSequences = new StringList();
  if(text == null || typeof text != 'string') return sLSequences;

  // get all the tokens
  var linkregex = StringOperators.LINK_REGEX;
  text = text.toLowerCase().replace(linkregex, "");
  // regexp \w in javascript is same as [A-Za-z_0-9] and does not include accented characters
  // This expression [A-Za-z_0-9À-ÖØ-öø-ÿ] works for latin-based languages but not Cyrillic or Chinese
  // We also want to include embedded ' or - characters
  var tokens = text.match(/[A-Za-z_0-9À-ÖØ-öø-ÿ]+(['-][A-Za-z_0-9À-ÖØ-öø-ÿ])?[A-Za-z_0-9À-ÖØ-öø-ÿ]*|[\.,-\/#!$%\^&\*;:{}=\-_`~()@\+\?><\[\]\+]/g);
  if(tokens == null) return sLSequences;
  tokens = StringList.fromArray(tokens);

  var rePunct = /[\.,-\/#!$%\^&\*;:{}=\-_`~()@\+\?><\[\]\+]/;

  for(i=0; i<tokens.length; i++){
    sSeq = tokens[i];
    if(stopWords && stopWords.indexOf(tokens[i]) != -1) continue;
    if(minSizeWords && tokens[i].length < minSizeWords) continue;
    if(tokens[i].length == 1 && tokens[i].match(rePunct)) continue;
    if(minSequenceSize == 1) sLSequences.push(sSeq);
    for(j=i+1; j < tokens.length && j < i+maxSequenceSize; j++){
      if(stopWords && stopWords.indexOf(tokens[j]) != -1) {
        if(iStopwordMode == 0)
          break;
      }
      if(minSizeWords && tokens[j].length < minSizeWords) break;
      if(tokens[j].length == 1 && tokens[j].match(rePunct)) break;
      if(j >= i + minSequenceSize - 1){
        sSeq = sSeq + ' ' + tokens[j];
        if(iStopwordMode == 2 && stopWords.indexOf(tokens[j]) != -1)
          continue;
        sLSequences.push(sSeq);
        if(limit !== 0 && sLSequences.length == limit) break;
      }
      else
        sSeq = sSeq + ' ' + tokens[j];
    }
    if(limit !== 0 && sLSequences.length == limit) break;
  }
  return sLSequences;
};

/**
 * Generate a random 128 bit GUID (UUID), an acronym for 'Globally Unique Identifier' (or 'Universally Unique Identifier'). It is a 128-bit integer number used to identify resources. 
 * @return {String}
 */
StringOperators.makeGuid = function() {
  
  // helper function
  var s4 = function(){
    return Math.floor((1 + mo.NumberOperators.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
};

/*
x+y (conca), x+y+z, x-y (remove text), x.substr(y, z), toLowerCase, toUpperCase, replace x by y, in x extract between y and z, length, words length, x--y (remove characters, specified as a string, example: %$#_)
 */
StringOperators.stringOperations = function(){

};

/**
 * builds a function based on a text that describes a function
 * @param  {String} text that defines a function in some of these ways: complete function definition ("function(a){return a+1}"), one line using a variable x ("Math.cos(x*2)"), or the name of a moebio framework function ("filterTable")
 * @return {Function}
 * tags:transform,conversion
 * examples:santiago/examples/stringToFunction
 */
StringOperators.stringToFunction = function(string){
  if(string==null) return;

  var realCode;
  var myTempraryFunction;

  if(string.search(/function\(/)!=-1){
    realCode = "myTempraryFunction = " + string;
    eval(realCode);
    return myTempraryFunction;
  }

  var func;
  for(var i=0; i<mo.methods.length; i++){
    if(mo.methods[i].methodName==string){
      if(mo.methods[i].isPrototype){
        var funcName = string;
        func = function(element, param0, param1, param2, param3, param4, param5){ 
          if(element[funcName]==null) return null;
          return element[funcName](param0, param1, param2, param3, param4, param5);
        };
      } else {
        func = mo.methods[i].func;
      }
      break;
    }
  }

  if(func!=null) return func;

  realCode = "myTempraryFunction = function(x){return " + string + "}";
  eval(realCode);
  return myTempraryFunction;
};

/**
 * remaps the characters in a string to new locations based on example input and output patterns. This is a positional remapping and does not depend on the characters of the input.
 * @param  {string|StringList|number} text is the input string (or StringList) to operate on
 * @param  {string|number} inputPattern is the input pattern with each character unique. It must have the same length as each input string. The characters are used as positional markers and do not need to match the contents of the input string.
 * @param  {string|number} outputPattern is the output pattern. Any character that is in the input pattern indicates the new position. Any character not in the input pattern is emitted as is.
 *
 * @param  {number} method to handle input with wrong length<|>0: output the original value (default)<|>1: output a null value<|>2: throw an error in this case
 * @return {string|StringList}
 * tags:transform
 * examples:jeff/examples/stringFormat
 */
StringOperators.stringFormat = function(string,inputPattern,outputPattern,method){
  if(string == null || inputPattern == null || outputPattern == null) return null;
  method = method == null ? 0 : method;
  var i,j;
  if(string.type == 'StringList' || typeOf(string) == 'Array'){
    // operate on each element
    var sLRet = new StringList();
    sLRet.name = string.name;
    for(i=0;i<string.length;i++){
      sLRet.push(StringOperators.stringFormat(string[i], inputPattern, outputPattern, method));
    }
    return sLRet;
  }
  string = typeof string != 'string' ? String(string) : string;
  inputPattern = typeof inputPattern != 'string' ? String(inputPattern) : inputPattern;
  outputPattern = typeof outputPattern != 'string' ? String(outputPattern) : outputPattern;
  // handle single string case
  if(string.length != inputPattern.length){
    if(method == 0)
      return string;
    else if(method == 1)
      return null;
    throw new Error('Input string must be same length as the input pattern');
  }
  if(new Set(inputPattern).size != inputPattern.length)
    throw new Error('All characters in the input pattern must be unique');

  var sOutput = outputPattern;
  for(i=0; i < outputPattern.length; i++){
    j = inputPattern.indexOf(outputPattern[i]);
    if(j != -1)
      sOutput = sOutput.substring(0,i) + string[j] + sOutput.substring(i+1);
  }
  return sOutput;
}
